import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { ForeignCurrencyConfig, ForeignCurrencyPriceHelper } from "../../Lib/Helper/ForeignCurrencyPriceHelper";
import { CrossSaleSelectionHelper } from "../../Lib/Helper/AxProdSelection/CrossSaleSelectionHelper";
import { CustomerLessonProperties, CustomerLessonPropertiesInit } from "../Account/CustomerLessonProperties";

export interface LessonBuyerInfoInit {
    lessonPropsHolderIs: string[];
    lessonParticipantsAmount: number;
    discounts: LessonDiscount[];
    isPrivateLesson: boolean;
    price: number;
    maxParticipants: number;
    /** Cross-sale offer: discount (percent) of the first participant, null without discount. */
    crossSaleDiscountPercent?: number;
    datepickerFormat: string;
    datepickerLanguage: string;
    datepickerWeekStart: number;
    foreignCurrency?: ForeignCurrencyConfig;
}

export interface LessonDiscount {
    personPosition: number;
    discountPercentage: number;
}

class initCustomerProps implements CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;

    constructor(parentId: string, formElementPrefix: string) {
        this.parentId = parentId;
        this.formElementPrefix = formElementPrefix;
    }
}

@ModuleName("LessonBuyerInfoModule")
export class LessonBuyerInfoModule implements AxInit {

    private _data: LessonBuyerInfoInit;
    private foreignCurrencyHelper: ForeignCurrencyPriceHelper;
    AxInit(lessonBuyerInfoInit: LessonBuyerInfoInit): void {
        this._data = lessonBuyerInfoInit;
        this.foreignCurrencyHelper = new ForeignCurrencyPriceHelper(lessonBuyerInfoInit.foreignCurrency);

        for (let i = 0; i < this._data.lessonPropsHolderIs.length; i++) {

            let id = this._data.lessonPropsHolderIs[i];
            this.initCustomerPropsDropDowns(id);
        }
        this.initAddElement();
        this.initRemovElement();
        this.InitDatePicker();

        const newIndex = $('[data-participant-detail]').length;
        this.UpdateData(newIndex);
    }

    initCustomerPropsDropDowns(id: string) {
        let customerLessonProps = new CustomerLessonProperties();
        customerLessonProps.AxInit(new initCustomerProps("#lessonProps_" + id, `ParticipantInfos[${id}].`));
    }

    initAddElement(): void {
        $('[data-buyer-information-add]').on('click', () => {
            const index = $('[data-participant-detail]').length;

            const data = {
                index: index,
                lessonAgeFrom: $('#LessonResultsItem_AgeFrom').val(),
                lessonAgeTo: $('#LessonResultsItem_AgeTo').val(),
                lessonDateFrom: $('#From').val()
            }

            AxessViewer.loadPartialView('/LessonsBooking/AddParticipantSlot', data, (result) => {
                $('[data-participant-section]').append(result);
                this.initCustomerPropsDropDowns(`${index}`);
                const newIndex = $('[data-participant-detail]').length;

                this.UpdateData(newIndex);
                this.InitDatePicker();
            }, {
                dataType: 'html'
            });

        });
    }

    initRemovElement(): void {
        $(document.body).on('click', '[data-buyer-information-remove]', (e) => {
            const target = $(e.currentTarget).data('buyer-information-remove');
            let participants = $('[data-participant-detail]').toArray();
            participants.splice(target, 1);
            const dataSection = $('[data-participant-section]');
            dataSection.html('');
            participants.forEach((p, index) => {
                const $p = $(p);
                this.restoreDropdownState($p);
                const htmlContent = this.UpdateIndexForElements($p, index);
                dataSection.append(htmlContent);
                this.initCustomerPropsDropDowns(`${index}`);
            });
            const index = $('[data-participant-detail]').length;
            this.UpdateData(index);
            this.InitDatePicker();
            if (target == 0) {

            }
            else {

            }
        });
    }

    /**
     * Restores dropdown DOM to a clean state before outerHTML capture.
     * 
     * AxDropdown uses Tippy.js, which moves the <ul> menu out of the
     * component into document.body. When outerHTML is captured, the menu
     * is missing but the rendered badge markup inside .ax-dropdown__selection
     * is still present. Re-initializing AxDropdown then creates duplicate badges.
     *
     * This method:
     * 1. Moves the Tippy-detached <ul> menu back into the dropdown element.
     * 2. Clears rendered badge markup from .ax-dropdown__selection.
     * 3. Keeps the .selected class on <li> items so AxDropdown.init() will
     *    re-render the badges correctly on re-initialization.
     */
    private restoreDropdownState($wrapper: JQuery<HTMLElement>): void {
        $wrapper.find('.ax-dropdown').each(function () {
            const $dropdown = $(this);
            const tippyInstance = (this as any)._tippy;

            if (tippyInstance) {
                const $menu = $(tippyInstance.popper).find('.ax-dropdown__menu');
                if ($menu.length > 0) {
                    $dropdown.append($menu);
                }
                tippyInstance.destroy();
            }

            $dropdown.find('.ax-dropdown__selection').html('');
            $dropdown.find('.ax-dropdown__trigger')
                .removeClass('has-selection')
                .removeClass('active');
        });
    }

    UpdateIndexForElements($wrapper, index) {
        $wrapper.data('participant-detail', index);
        $wrapper.find('[data-participant-number]').html(index + 1);
        $wrapper.find('#participantIdHidden').val(index);

        let divContent = $wrapper.prop('outerHTML');
        divContent = divContent.replace(/(lessons_buyerInfo_participants_\S*)(\d+)/g, `$1${index}`);
        divContent = divContent.replace(/(ParticipantInfos_)(\d+)/g, `$1${index}`);
        divContent = divContent.replace(/(ParticipantInfos)(\[\d+\])/g, `$1[${index}]`);
        divContent = divContent.replace(/(data-index=")(\d+)/g, `$1${index}`);
        divContent = divContent.replace(/(lessonProps_)(\d+)/g, `$1${index}`);
        divContent = divContent.replace(/(data-buyer-information-remove=")(\d+)"/g, `$1${index}"`);

        return divContent;
    }

    UpdateData(participants: number) {
        $('[data-lesson-participants]').html(`${participants}`);

        // cross-sale offer: discount of the first participant (the shopping cart discounts only one), in the base price and the total
        const crossSaleDiscount = participants > 0
            ? CrossSaleSelectionHelper.getLessonDiscount(this.GetPriceValue(1), this._data.price, this._data.crossSaleDiscountPercent)
            : 0;

        //Product Summary -> Total
        const totalPrice = this.GetTotalPrice(participants) - crossSaleDiscount;
        let totalPriceString = this.GetTariffString(totalPrice.toString());


        //Product Summary -> Base Price
        const basePrice = this.GetPriceValue(1) - crossSaleDiscount;
        let basePriceString = this.GetTariffString(basePrice.toString());
        
        //Product Summary -> Base Price Show/Hide
        $('[data-product-summary-base]').toggleClass('d-none', participants == 0)
            .toggleClass('d-flex', participants > 0);

        //Product Summary -> Additional participant
        const participantsPrice = totalPrice - basePrice;
        let participantsPriceString = this.GetTariffString(participantsPrice.toString());
        
        //Product Summary -> Additional participant Show/Hide
        $('[data-product-summary-additional-participant]').toggleClass('d-none', participants < 2)
            .toggleClass('d-flex', participants > 1);

        if (this.foreignCurrencyHelper.isEnabled())
        {
            totalPriceString = totalPriceString + '&nbsp;' + this.foreignCurrencyHelper.getForeignCurrencyHtml(totalPrice);
            basePriceString = basePriceString + '&nbsp;' + this.foreignCurrencyHelper.getForeignCurrencyHtml(basePrice);
            participantsPriceString = participantsPriceString + '&nbsp;' + this.foreignCurrencyHelper.getForeignCurrencyHtml(participantsPrice);
        }

        $('[data-lesson-price]').html(totalPriceString);
        $('[data-base-price]').html(basePriceString);
        $('[data-participants-price]').html(participantsPriceString);
        //Button Add Participant
        const addNextParticipantPrice = this.GetPriceValue(participants + 1);
        $('[data-additional-participant-price]').text(this.GetTariffString(addNextParticipantPrice.toString()));
        //Button Add Participant -> Show/Hide
        $('[ data-buyer-information-add]').toggleClass('d-none', participants >= this._data.maxParticipants)
            .toggleClass('d-flex flex-row', participants < this._data.maxParticipants);

        //Add to cart Button -> Enable/Disable
        $('[data-add-to-cart-button]').prop('disabled', participants == 0);
    }

    GetTotalPrice(participants: number) {
        if (participants == 0) {
            return 0;
        }

        let calculatedPrice = this._data.price * participants;

        if (this._data.isPrivateLesson && this._data.discounts?.length > 0 && participants > 0) {
            calculatedPrice = 0;

            for (let i = 1; i <= participants; i++) {
                calculatedPrice += this.GetPriceValue(i);
            }
        }

        return calculatedPrice;
    }

    GetPriceValue(participantIndex: number) {
        if (!this._data.isPrivateLesson || this._data.discounts?.length == 0 || participantIndex == 0) {
            return this._data.price;
        }

        const minIndex = Math.min(...this._data.discounts.map(d => d.personPosition));
        const maxIndex = Math.max(...this._data.discounts.map(d => d.personPosition));

        let discount = null;
        if (participantIndex < minIndex) {
            discount = null;
        }
        else if (participantIndex >= maxIndex) {
            discount = this._data.discounts[0];
        }
        else {
            discount = this._data.discounts.find(d => d.personPosition == participantIndex);
        }

        if (!discount || (discount && discount.discountPercentage == 0)) {
            return this._data.price;
        }

        return this._data.price - (this._data.price * (discount.discountPercentage / 100));
    }

    GetTariffString(value) {

        if (isNaN(parseFloat(value))) return "";

        return (parseFloat(value) / 100).toFixed(2);
    }

    InitDatePicker() {
        $('input.lessons_buyerInfo_participants_input_date').datepicker({
            format: this._data.datepickerFormat,
            language: this._data.datepickerLanguage,
            weekStart: this._data.datepickerWeekStart
        });
    }
}